import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenter } from '../../../Defaults/Flexbox/Flexbox';
import { SummaryValue } from './SummaryValue';
import { FinalValue } from './FinalValue';
import { getCartSummaryInfo } from '../../../../utilities/selectors';
import { formatPriceToString } from '../../../../utilities';
import { Loader } from './ThirdStep';
import { CartInfoPopup } from './CartInfoPopup';
import { getZemplinCartSummaryInfo } from '../../../Zemplin/selectors';
import { InfoText, InfoType } from '../../../Zemplin/General/InfoText';
import { Button } from '../../../Zemplin/General/Button';

interface Props {
  handleStepChange?: (step: number) => void;
  withoutBottomPart?: boolean;
  data: any;
  isFetching: boolean;
  isDemand: boolean;
  hasPartlyOnStockItem: number;
  cartB2BDiscount: number;
}

function SecondStep({
  handleStepChange,
  data,
  withoutBottomPart = false,
  isFetching,
  isDemand,
  hasPartlyOnStockItem,
  cartB2BDiscount,
}: Props) {
  const {
    totalPrice,
    totalPriceWithoutVat,
    vatTotal,
    currency,
    totalItemsPrice,
    totalItemsPriceWithoutVat,
  } = getCartSummaryInfo(data);
  const {
    vatGroup0Total,
    vatGroup0TotalWithDph,
    vatGroup20Total,
    vatGroup20TotalDph,
    vatGroup20TotalWithDph,
  } = getZemplinCartSummaryInfo(data);
  const { items } = data;
  const hasNullPriceItems = items.some(i => i.sum_price === 0);

  const handleNextStep = () => {
    console.log('next step');
    if (handleStepChange) {
      handleStepChange(3);
    }
  };
  return (
    <>
      <DesktopFields>
        <SummaryValue
          borderBottom={false}
          title={__('Cena bez DPH')}
          value={`${totalPriceWithoutVat} ${currency}`}
        />
        <SummaryValue
          borderBottom={true}
          title={__('DPH 20 %')}
          value={`${vatTotal} ${currency}`}
        />
        <FinalValue
          title={__('Celkom k úhrade s DPH')}
          value={`${totalPrice} ${currency}`}
        />
      </DesktopFields>
      <MobileFields>
        <SummaryValue
          title={__('Cena bez DPH')}
          value={`${totalPriceWithoutVat} ${currency}`}
        />
        <SummaryValue
          title={__('DPH 20 %')}
          value={`${vatTotal} ${currency}`}
        />
        <SummaryValue
          title={__('Cena s DPH')}
          value={`${totalPrice} ${currency}`}
        />
      </MobileFields>
      {!withoutBottomPart && (
        <>
          {false && hasNullPriceItems && (
            <InfoText
              type={InfoType.INFO}
              noIcon={true}
              info={__(
                'Pozor! V košíku sa vyskytujú produkty, ktoré nemajú uvedenú cenu. Ich cena vám bude započítaná do faktúry.',
              )}
              marginBottom={24}
            />
          )}
          <NextButton
            disabled={isFetching}
            // tslint:disable-next-line:jsx-no-lambda
            onMouseDown={handleNextStep}
          >
            {isFetching ? (
              <FlexRowCenter>
                <Loader className="marginLeft" small={true} />
              </FlexRowCenter>
            ) : isDemand ? (
              __('Pokračovať k osobným údajom')
            ) : (
              __('Pokračovať v objednávke')
            )}
          </NextButton>
          <BackButton
            // tslint:disable-next-line:jsx-no-lambda
            onClick={() => (handleStepChange ? handleStepChange(1) : {})}
          >
            {__('Späť')}
          </BackButton>
        </>
      )}
    </>
  );
}

const NextButton = styled(Button)`
  height: ${rem(48)};
  margin: ${rem(15)} 0 0;
  padding: ${rem(8)};
  width: 100%;
  max-width: ${rem(320)};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: 0 0 ${rem(16)};

  &:disabled {
    background-color: #f9f9f9;
    color: #cccccc;
  }
`;

const BackButton = styled(NextButton)`
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => theme.borders.primary};
  color: ${({ theme }) => theme.colors.black};
`;

const DesktopFields = styled(FlexCol)`
  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const MobileFields = styled(FlexCol)`
  display: none;
  margin-bottom: ${rem(16)};
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    display: flex;
  `}
`;

export { SecondStep };
